import React, { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';

import LoginPage from './pages/LoginPage';
import Dashboard from './pages/Dashboard';
import InvoicePage from './pages/InvoicePage';
import InvoiceListPage from './pages/InvoiceListPage';
import ReportsPage from './pages/ReportsPage';
import CompanySettingsPage from './pages/CompanySettingsPage';
import PrivateRoute from './components/PrivateRoute';
import InvoiceCreatePage from './pages/InvoiceCreatePage';
import InvoiceViewPage from './pages/InvoiceViewPage';
import CustomerPage from './pages/CustomerPage';
import InvoicePaymentPage from './pages/InvoicePaymentPage';
import 'bootstrap-icons/font/bootstrap-icons.css';
import LogoPage from './pages/LogoPage';
import QRCodePage from './pages/QRCodePage';
import InvoiceEditPage from './pages/InvoiceEditPage';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ProductPage from './pages/ProductPage';
import SupplierListPage from './pages/SupplierListPage';
import PurchaseBillListPage from './pages/PurchaseBillListPage';
import PurchaseBillFormPage from './pages/PurchaseBillFormPage';
import PurchaseBillItemsPage from './pages/PurchaseBillItemsPage';
import PurchaseBillPaymentsPage from './pages/PurchaseBillPaymentsPage';
import SupplierLedgerPage from './pages/SupplierLedgerPage';
import CustomerLedgerPage from './pages/CustomerLedgerPage';
import CashBankAccountsPage from './pages/CashBankAccountsPage';
import CashBookPage from './pages/CashBookPage';
import RefundPage from './pages/RefundPage';
import PaymentsPage from './pages/PaymentsPage';
import OneSignal from 'react-onesignal';
export default function App() {
  useEffect(()=>{
    OneSignal.init({ 
      appId: "3ffe9866-5377-4a2b-a666-3ea4b9814a7e",
      safari_web_id: "web.onesignal.auto.4b51c712-23a7-447d-a673-6f24b07d407b",
      notifyButton: {
        enable: true,
      },
      allowLocalhostAsSecureOrigin: true,
    });
  });
  return (
    <>
      {/* ✅ Toast container should be outside */}
      <ToastContainer position="top-right" autoClose={2000} />

      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
        <Route path="/invoice" element={<PrivateRoute><InvoiceCreatePage /></PrivateRoute>} />
        <Route path="/invoices" element={<PrivateRoute><InvoiceListPage /></PrivateRoute>} />
        <Route path="/reports" element={<PrivateRoute><ReportsPage /></PrivateRoute>} />
        <Route path="/settings" element={<PrivateRoute><CompanySettingsPage /></PrivateRoute>} />
        <Route path="/customers" element={<PrivateRoute><CustomerPage /></PrivateRoute>} />
        <Route path="/invoice/payment/:invoiceId" element={<PrivateRoute><InvoicePaymentPage /></PrivateRoute>} />
        <Route path="/logo" element={<PrivateRoute><LogoPage /></PrivateRoute>} />
        <Route path="/qrcode" element={<PrivateRoute><QRCodePage /></PrivateRoute>} />
        <Route path="/products" element={<PrivateRoute><ProductPage /></PrivateRoute>} />
  <Route path="/suppliers/:id/ledger" element={<PrivateRoute><SupplierLedgerPage /></PrivateRoute>} />

  <Route path="/suppliers" element={<PrivateRoute><SupplierListPage /></PrivateRoute>} />
 
<Route path="/purchase-bills" element={<PrivateRoute><PurchaseBillListPage /></PrivateRoute>} />
  <Route path="/purchase-bills/add" element={<PrivateRoute><PurchaseBillFormPage /></PrivateRoute>} />
  <Route path="/purchase-bills/edit/:id" element={<PrivateRoute><PurchaseBillFormPage /></PrivateRoute>} />
<Route path="/purchase-bills/items/:billId" element={<PrivateRoute><PurchaseBillItemsPage /></PrivateRoute>} />

<Route path="/purchase-bills/payments/:billId" element={<PrivateRoute><PurchaseBillPaymentsPage /></PrivateRoute>} />
<Route path="/customers/:id/ledger" element={<CustomerLedgerPage />} />
<Route path="/cashbank-accounts" element={<PrivateRoute><CashBankAccountsPage /></PrivateRoute>} />
<Route path="/cashbook" element={<PrivateRoute><CashBookPage /></PrivateRoute>} />
<Route path="/refunds" element={<PrivateRoute><RefundPage /></PrivateRoute>} />
<Route path="/payments" element={<PrivateRoute><PaymentsPage /></PrivateRoute>} />


        <Route path="/invoice/view/:invoiceId" element={<InvoiceViewPage />} />
        <Route path="/invoice/edit/:invoiceId" element={<InvoiceEditPage />} />

        <Route path="*" element={<LoginPage />} />
      </Routes>
    </>
  );
}
